import { Routes } from '@angular/router';
import { TemplateComponent as CustomerTemplate } from 'src/app/pages/customer/template/template.component';
import { TemplateComponent as SystemAdminTemplate } from 'src/app/pages/system-admin/template/template.component';
import { TemplateComponent as FaeTemplate } from 'src/app/pages/fae/template/template.component';
import { TemplateComponent as TsmTemplate } from 'src/app/pages/tsm/template/template.component';
import { TemplateComponent as ProductAdminTemplate } from 'src/app/pages/product-admin/template/template.component';
import { TemplateComponent as TsTemplate } from 'src/app/pages/ts/template/template.component';
import { TemplateComponent as ApproverTemplate } from 'src/app/pages/approver/template/template.component';
import { TemplateComponent as PublicTemplate } from 'src/app/pages/public/template/template.component';
import { TemplateComponent as CsrTemplate } from 'src/app/pages/csr/template/template.component';
import { PasswordUpdateComponent } from 'src/app/pages/common/password-update/password-update.component';
import { authGuard } from './guards/auth/auth.guard';
import { roleGuard } from './guards/role/role.guard';
import { sessionGuard } from './guards/session/session.guard';
import { forceUpdateGuard } from 'src/app/guards/force-update/force-update.guard';
import { AuthComponent } from 'src/app/pages/public/auth/auth.component';
import { ProfileComponent as ProfileTemplate } from './pages/account/profile/profile.component';
import {OauthComponent} from "src/app/pages/public/oauth/oauth.component";
import { RedirectComponent } from './pages/redirect/redirect.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('src/app/pages/public/public.module').then((m) => m.PublicModule),
    component: PublicTemplate,
  },
  {
    path: 'login',
    title: 'Login | HPI Marketplace',
    component: AuthComponent,
  },
  {
    path: 'oauth',
    component: OauthComponent,
    title: 'Oauth Redirect',
  },
  {
    path: 'password_update',
    canActivate: [authGuard],
    component: PasswordUpdateComponent,
  },
  {
    path: 'user/profile',
    component: ProfileTemplate,
    title: 'Profile | HPI Marketplace',
  },
  {
    path: 'browse',
    title: 'Browse | HPI Marketplace',
    component: CustomerTemplate,
    canActivate: [authGuard],
    data: { roles: ['customer'] },
    loadChildren: () =>
      import('src/app/pages/customer/customer.module').then(
        (m) => m.CustomerModule,
      ),
  },
  {
    path: 'sysad',
    component: SystemAdminTemplate,
    canActivate: [authGuard, sessionGuard, roleGuard],
    data: { roles: ['system_admin'] },
    loadChildren: () =>
      import('src/app/pages/system-admin/system-admin.module').then(
        (m) => m.SystemAdminModule,
      ),
  },
  {
    path: 'fae',
    component: FaeTemplate,
    data: { roles: ['fae'] },
    canActivate: [authGuard, forceUpdateGuard, sessionGuard, roleGuard],
    loadChildren: () =>
      import('src/app/pages/fae/fae.module').then((m) => m.FaeModule),
  },
  {
    path: 'tsm',
    component: TsmTemplate,
    data: { roles: ['tsm'] },
    canActivate: [authGuard, forceUpdateGuard, sessionGuard, roleGuard],
    loadChildren: () =>
      import('src/app/pages/tsm/tsm.module').then((m) => m.TsmModule),
  },
  {
    path: 'ts',
    component: TsTemplate,
    data: { roles: ['ts'] },
    canActivate: [authGuard, forceUpdateGuard, sessionGuard, roleGuard],
    loadChildren: () =>
      import('src/app/pages/ts/ts.module').then((m) => m.TsModule),
  },
  {
    path: 'product-admin',
    component: ProductAdminTemplate,
    data: { roles: ['product_admin'] },
    canActivate: [authGuard, forceUpdateGuard, sessionGuard, roleGuard],
    loadChildren: () =>
      import('src/app/pages/product-admin/product-admin.module').then(
        (m) => m.ProductAdminModule,
      ),
  },
  {
    path: 'approver',
    component: ApproverTemplate,
    data: { roles: ['approver'] },
    canActivate: [authGuard, forceUpdateGuard, sessionGuard, roleGuard],
    loadChildren: () =>
      import('src/app/pages/approver/approver.module').then(
        (m) => m.ApproverModule,
      ),
  },
  {
    path: 'csr',
    component: CsrTemplate,
    data: { roles: ['csr'] },
    canActivate: [authGuard, forceUpdateGuard, sessionGuard, roleGuard],
    loadChildren: () =>
      import('src/app/pages/csr/csr.module').then((m) => m.CsrModule),
  },
  {
    path: 'quotation-editor/:uuid',
    data: { roles: ['fae'] },
    canActivate: [authGuard, roleGuard],
    loadComponent: () => import('./shared/quotations/view/internal/quotation-editor/quotation-editor.component') .then(m => m.QuotationEditorComponent),
  },
  {
    path: 'redirect',
    component: RedirectComponent
  },
  {
    path: '**',
    redirectTo: '',
  },
];
